import React from "react";
import { RouteComponentProps } from "react-router-dom";
import GenericErrorPage from "../../../ErrorPages/Components/GenericErrorPage";

type TParams = {
  id: string;
};

export const AppSubscriptionExpired: React.FC<RouteComponentProps<TParams>> = props => {
  const myDescription: string = `Your subscription to app with code "${props.match.params.id}" has expired. Please contact your CMCORE Administrator`;

  return (
    <GenericErrorPage
      src="https://http.cat/403"
      alt="Forbidden"
      heading="Subscription Expired!"
      description={myDescription}
    />
  );
};
